import { ReactComponent as CloseIcon } from 'assets/icons/close.svg';
import IconButton from 'components/IconButton/IconButton';

import Panel from '../../../../../../components/Panel/Panel';

import type { ICreateSurveyItemPanel } from '../interfaces/ICreateSurveyItemPanel';

import styles from '../scss/CreateSurvey.module.scss';

function CreateSurveyItemPanel({
  children,
  title,
  description = undefined,
  onDelete = undefined,
}: ICreateSurveyItemPanel) {
  return (
    <Panel className={styles.panel}>
      <div className={styles.panelHeader}>
        <div className={styles.panelTitleSection}>
          <p className={styles.title}>{title}</p>
          {description ? <p className={styles.description}>{description}</p> : null}
        </div>
        {onDelete ? (
          <IconButton
            icon={<CloseIcon />}
            onClick={onDelete}
            className={styles.deleteButton}
          />
        ) : null}
      </div>
      {children}
    </Panel>
  );
}

export default CreateSurveyItemPanel;
